<template>
  <div class="level container">
    <div class="row">
      <div class="col-md-10">
        <router-link  class="btn draw-border back" :to="{ name: 'Home' }">
            Back
        </router-link>
      </div>
      <div class="col-md-2">
        <div class="menu-instruction-heading d-none d-md-block ">
          <h5 class="graphik-light-web">
            Level Select
          </h5>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-md-10">
        <h5 class="graphik-light-web">
          <span v-if="this.$route.params.level != 0">
            Level {{ this.$route.params.level }}
          </span>
          <span v-else>
            Ground
          </span>
        </h5>
        <div class="image-wrapper floorplate-wrapper animated fadeInUp">
          <lvl0SVG v-if="this.$route.params.level == 0"></lvl0SVG>
          <lvl1SVG v-if="this.$route.params.level == 1"></lvl1SVG>
          <lvl2SVG v-if="this.$route.params.level == 2"></lvl2SVG>
          <lvl3SVG v-if="this.$route.params.level == 3"></lvl3SVG>
          <lvl4SVG v-if="this.$route.params.level == 4"></lvl4SVG>
          <lvl5SVG v-if="this.$route.params.level == 5"></lvl5SVG>
          <!-- Images get chunked, cant do straight up template
              literal due to chunk... require workaround needed -->
          <img :src="require(`@/assets/floorplate/L${this.$route.params.level}.jpg`)" alt="Level image">
        </div>
        <div class="clearfix"></div>
      </div>

      <div class="col-md-2 ">
        <ul class="menu-list">

          <li v-for="(curApt, index) in orderedApts" :key="index"  class="animated fadeInUp" :style="{ 'animation-delay': `${index*200}ms` }" >

            <router-link v-if="curApt.status_id == 1" class="btn draw-border"   :to="{ name: 'apartment', params: { apartment: curApt.name }}">
              Apt {{ curApt.name }}
            </router-link>
            <div v-else class="btn draw-border animated fadeInUp sold">
              Apt {{ curApt.name }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .svg-floorplate {
    fill: $plazaGardenTransparent;
  }
  .svg-transparent {
    fill: rgba(0,0,0,0)
  }


</style>


<script>


import lvl0SVG from "@/components/Level0";
import lvl1SVG from "@/components/Level1";
import lvl2SVG from "@/components/Level2";
import lvl3SVG from "@/components/Level3";
import lvl4SVG from "@/components/Level4";
import lvl5SVG from "@/components/Level5";



export default {
  components: {
    lvl0SVG,
    lvl1SVG,
    lvl2SVG,
    lvl3SVG,
    lvl4SVG,
    lvl5SVG,
  },
  data() {
    return {
      apts: ''
    }
  },
  computed: {
    orderedApts: function () {
      return _.orderBy(this.apts, parseInt(('name'),10))
    }
  },
  mounted() {
    this.apts = this.$store.getters.getApartmentsByLevel(this.$route.params.level);
  }
}


// Message received on discord
// computed: {
//     dynamicComp() {
//         const i = this.compName // This is needed for reactivity to work if you're changing the comp.
//         return () => import(`@/path/to/file/${i}.vue`);
//     }
// }

// <component :is="dynamicComp" />
</script>
